import { FC } from "react";

interface appleSVGProps {
    width?: number;
    height?: number;
}

const AppleSVG: FC<appleSVGProps> = ({ width = "18px", height = "18px" }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 18 18"
            fill="none"
        >
            <path
                d="M11.4747 2.87081C11.8149 2.47869 12.0743 2.02322 12.238 1.53056C12.4017 1.0379 12.4665 0.517761 12.4286 0C11.3841 0.0843127 10.4145 0.575562 9.72879 1.36791C9.4004 1.74766 9.15155 2.18945 8.99697 2.6671C8.84239 3.14476 8.78522 3.64858 8.82885 4.14872C9.33835 4.15297 9.84199 4.03992 10.3008 3.81832C10.7596 3.59672 11.1613 3.27252 11.4747 2.87081ZM13.7425 9.56636C13.7486 8.87677 13.9302 8.20009 14.2703 7.60018C14.6104 7.00026 15.0978 6.4969 15.6864 6.13759C15.3149 5.60234 14.8238 5.16101 14.2521 4.84858C13.6804 4.53616 13.0437 4.36125 12.3926 4.33771C10.9887 4.19372 9.69279 5.15666 8.94584 5.15666C8.19889 5.15666 7.14596 4.35571 5.97604 4.37371C5.21121 4.3989 4.46596 4.6219 3.81299 5.02093C3.16002 5.41997 2.62161 5.98144 2.25029 6.65056C0.666395 9.40438 1.84532 13.4991 3.42921 15.722C4.14916 16.8109 5.0491 18.0438 6.23702 17.9988C7.42495 17.9538 7.81192 17.2609 9.18883 17.2609C10.5657 17.2609 10.9887 17.9988 12.1586 17.9718C13.3286 17.9448 14.1565 16.8559 14.9124 15.767C15.448 14.9764 15.8663 14.1125 16.1544 13.2021C15.4411 12.898 14.8326 12.3915 14.404 11.7454C13.9754 11.0993 13.7454 10.3417 13.7425 9.56636Z"
                fill="black"
            />
        </svg>
    );
};

export default AppleSVG;
